<div class="workshops-layout">
  <div class="workshops-layout__list">
    <app-workshop-list
      [workshops]="filteredWorkshops"
      [selectedWorkshop]="selectedWorkshop"
      [isLoading]="isLoading"
      (workshopSelected)="onSelectWorkshop($event)">
    </app-workshop-list>
  </div>

  <div class="workshops-layout__detail">
    @if (viewState === 'map') {
      <app-workshop-map [workshopLocations]="filteredWorkshopLocations" [isLoading]="isLoading" (workshopMarkerClicked)="onMarkerClicked($event)"></app-workshop-map>
    }
    @if (viewState === 'edit') {
      <app-workshop-detail
        [isLoading]="isDetailsLoading"
        [isSaving]="isSaving"
        [isDeleting]="isDeleting"
        [workshop]="workshopDetails"
        [mode]="'edit'"
        (cancel)="onCancel()"
        (save)="onSave($event)"
        (delete)="onDelete($event)">
      </app-workshop-detail>
    }
    @if (viewState === 'add') {
      <app-workshop-detail
        [isSaving]="isSaving"
        [mode]="'add'"
        (cancel)="onCancel()"
        (save)="onSave($event)">
      </app-workshop-detail>
    }
  </div>
</div>